import { Controller } from "@hotwired/stimulus"

// Toggles CSS-driven expand/collapse (grid-template-rows 0fr ↔ 1fr).
export default class extends Controller {
  static targets = ["panel", "ellipsis", "toggle"]

  connect() {
    this.expanded = false
    this.sync()
  }

  toggle(event) {
    event.preventDefault()
    this.expanded = !this.expanded
    this.sync()
  }

  sync() {
    this.panelTarget.classList.toggle("is-open", this.expanded)
    this.ellipsisTarget.classList.toggle("hidden", this.expanded)
    this.toggleTarget.textContent = this.expanded ? "read less" : "read more"
    this.toggleTarget.setAttribute("aria-expanded", String(this.expanded))
  }
}
